'use strict';

/**
 * @ngdoc function
 * @name prepApp.controller:HomeController
 * @description
 * # HomeController
 * Controller of the prepApp
 */
angular.module('prepApp')
    .controller('HomeController', function (CONFIG) {
        var vm = this;
        vm.imagePath = CONFIG.imagePath;
    });
